import React from 'react';
import { motion } from 'framer-motion';
import Container from '../../layout/Container';
import SectionHeading from '../../common/SectionHeading';
import companyLogo from '../../../utils/images/company_logo.png';

const CompanyIntro = () => {
  return (
    <section className="pt-20 pb-16 bg-white">
      <Container>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="max-w-4xl mx-auto text-center"
        >
          <SectionHeading
            title="About Bytematic IT Solutions"
            subtitle="A vibrant and dynamic company specializing in computer hardware and peripherals."
            center
          />
          
          <p className="text-gray-600 mt-6">
            Founded with a mission to provide exceptional IT infrastructure solutions, Bytematic has grown 
            into a trusted partner for businesses of all sizes. Our team of dedicated professionals brings 
            decades of combined experience in hardware, software, and IT services, ensuring that we can 
            address the unique challenges facing modern organizations.
          </p>
          
          <div className="mt-12 max-w-3xl mx-auto">
            <div className="relative aspect-video min-h-[300px] bg-gradient-to-br from-blue-50 to-blue-100 rounded-lg overflow-hidden flex items-center justify-center">
              <img
                src={companyLogo}
                alt="Bytematic IT Solutions Logo"
                className="max-w-full max-h-full object-contain"
              />
            </div>
          </div>
        </motion.div>
      </Container>
    </section>
  );
};

export default CompanyIntro;